// frontend/klaes-app/src/components/FilmFavs/components/RandomViewModal.jsx
import { useState } from 'react';
import { FiArrowLeft, FiStar } from 'react-icons/fi';
import { BatteryIndicator } from './BatteryIndicator';
import { Chip } from './Chip';
import { RatingPopup } from './RatingPopup';
import styles from '../FilmFavs.module.css';

export const RandomViewModal = ({ entry, users, currentUser, onClose, onRate }) => {
  const [showRatingPopup, setShowRatingPopup] = useState(false);
  const userRating = entry.user_ratings?.[currentUser];

  const handleUserRating = (rating, closePopup) => {
    onRate(entry.id, rating);
    closePopup(false);
  };

  return (
    <div className={styles.randomViewOverlay} onClick={onClose}>
      <div className={`${styles.randomViewModal} ${styles.highlightBorder}`} onClick={(e) => e.stopPropagation()}>
        <button className={styles.randomViewClose} onClick={onClose}>
          <FiArrowLeft /> Zurück zum Ranking
        </button>

        <div className={styles.randomViewContent}>
          <div className={styles.entryType}>{entry.type === 'film' ? '🎬 Film' : '📺 Serie'}</div>
          <h2 className={styles.randomViewName}>{entry.name}</h2>
          <p className={styles.randomViewDescription}>{entry.description}</p>

          <div className={styles.chipContainer}>
            {entry.tags?.map((tag, i) => (
              <Chip key={i} label={tag.name} category={tag.category} size="medium" />
            ))}
          </div>

          <div className={styles.randomViewRatings}>
            <div className={styles.averageRating}>
              <span className={styles.ratingLabel}>Ø Bewertung</span>
              <BatteryIndicator rating={entry.current_ranking} />
            </div>

            <div className={styles.userRating}>
              <span className={styles.ratingLabel}>Deine Bewertung</span>
              {userRating !== undefined ? (
                <BatteryIndicator 
                  rating={userRating} 
                  isUserRating 
                  onClick={() => setShowRatingPopup(true)}
                />
              ) : (
                <button 
                  className={`${styles.rateButton} ${styles.pulsate}`}
                  onClick={() => setShowRatingPopup(true)}
                >
                  <FiStar /> Bewerten
                </button>
              )}
            </div>
          </div>

          {showRatingPopup && (
            <RatingPopup 
              onRate={(rating) => handleUserRating(rating, setShowRatingPopup)}
              onClose={() => setShowRatingPopup(false)}
              currentRating={userRating}
            />
          )}
        </div>
      </div>
    </div>
  );
};